import { Button } from '@/components/ui/button';
import { whatsappLink } from '../site-config';
import { SiteContainer } from '../SiteUi';
import { SiteHeroDemo } from './SiteHeroDemo';

export function SiteHero() {
  return (
    <section className="pb-16 pt-10 sm:pb-24 sm:pt-16">
      <SiteContainer className="grid items-center gap-12 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] lg:gap-16">
        <div>
          <p className="text-sm text-[#5c5852]">ERP para oficinas e centros automotivos</p>
          <h1 className="mt-5 max-w-[12ch] text-balance font-display text-[clamp(2.75rem,6vw,4.75rem)] font-semibold leading-[0.98] tracking-tight text-[#16181d]">
            O sistema que traz seu cliente de volta.
          </h1>
          <p className="mt-6 max-w-[38ch] text-lg leading-relaxed text-[#5c5852]">
            Finalizou o serviço? O AgilizaOS sabe quando chamar esse cliente novamente e envia o
            lembrete pelo WhatsApp sozinho.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-5">
            <Button asChild variant="default">
              <a href={whatsappLink('Olá! Quero falar com um especialista do AgilizaOS.')} target="_blank" rel="noopener noreferrer">
                Falar com um especialista
              </a>
            </Button>
            <a
              href="#como-funciona"
              className="text-sm text-[#5c5852] underline-offset-4 hover:text-[#16181d] hover:underline"
            >
              Ver como funciona ↓
            </a>
          </div>
          <p className="mt-10 max-w-[46ch] text-sm text-[#5c5852]">
            OS, estoque, caixa, fiscal e financeiro trabalhando juntos.
          </p>
        </div>
        <SiteHeroDemo />
      </SiteContainer>
    </section>
  );
}

export function SiteTrustBar() {
  const items = ['100% na nuvem', 'NFC-e e NFS-e', 'Multi-filial', 'WhatsApp integrado', 'Implantação acompanhada'];
  return (
    <div className="border-y border-[#d9d4cc] bg-white">
      <SiteContainer className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 py-4 text-sm text-[#5c5852]">
        {items.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </SiteContainer>
    </div>
  );
}
